<template>
  <div class="container">
    <div v-if="loading" class="text-center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <div v-else class="autocomplete" ref="autocomplete">
        <div class="input-group mb-0">
      <input
        class="form-control search"
        type="text"
        v-model="keyword"
        @input="onInput"
        @keydown="onKeyDown"
        @keyup="handleEnterKey"
        placeholder="Search for products"
        @focus="showSuggestions = true"/>
    <div class="input-group-append">
      <button class="btn btn-dark px-4 py-0" 
      @click="goToSearchPage"
      type="button">
        <img src="/images/search.svg" width="16" />
      </button>
    </div>
        </div>

          <div
        v-if="showSuggestions && filteredSuggestions.length"
        class="autocomplete-items">
        <div
          v-for="(suggestion, index) in filteredSuggestions"
          :key="index"
          :class="['suggestion-item', index === currentIndex ? 'active' : '']"
          @click="selectSuggestion(suggestion)">
          {{ suggestion }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
props: ['keyword'],
  data() {
    return {
      keyword: null,
      suggestions: [],
      currentIndex: -1,
      filteredSuggestions: [],
      loading: false,
      showSuggestions: true,
    };
  },

  created() {
    this.getSuggestions();
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {

    handleEnterKey(event) {
    if (event.keyCode === 13) {
        this.goToSearchPage();
        }
    },

    goToSearchPage() {
      window.location.href = '/search/' + this.keyword;
    },

    getSuggestions() {
      this.loading = true;

      axios.get("/suggestions").then((response) => {
        this.suggestions = response.data;
        this.loading = false;
      });
    },

    onInput() {
        let maxSugggestions = 5;
      if (this.keyword) {
        const query = this.keyword.toLowerCase();

        // get the suggestions which contains the query
        this.filteredSuggestions = this.suggestions.filter((suggestion) =>
          suggestion.toLowerCase().includes(query)
        );

        // limit suggestions
        if (this.filteredSuggestions.length > maxSugggestions) {
          this.filteredSuggestions = this.filteredSuggestions.slice(0, maxSugggestions);
        }

        this.currentIndex = -1;
        this.showSuggestions = true; // Show suggestions on input
      } else {
        this.filteredSuggestions = [];
      }
    },

    onKeyDown(event) {
      const suggestionsLength = this.filteredSuggestions.length;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        if (this.currentIndex < suggestionsLength - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0; // Loop back to the top
        }
        this.setInputToSuggestion(this.currentIndex);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          this.currentIndex = suggestionsLength - 1; // Loop to the bottom
        }
        this.setInputToSuggestion(this.currentIndex);
      } else if (event.key === "Enter" && this.currentIndex !== -1) {
        event.preventDefault();
        this.selectSuggestion(this.filteredSuggestions[this.currentIndex]);
      }
    },

    setInputToSuggestion(index) {
      const selectedSuggestion = this.filteredSuggestions[index];
      if (selectedSuggestion) {
        this.keyword = selectedSuggestion;
        this.$nextTick(() => {
          const input = this.$el.querySelector("input");
          if (input) {
            input.focus();
            const length = input.value.length;
            input.setSelectionRange(length, length);
          }
        });
      }
    },

    selectSuggestion(suggestion) {
      this.keyword = suggestion;
      this.filteredSuggestions = []; // Hide suggestions
      this.showSuggestions = false; // Hide suggestions after selection
      this.goToSearchPage();
    },

    handleClickOutside(event) {
      // Check if the click is outside the autocomplete component
      if (
        this.$refs.autocomplete &&
        !this.$refs.autocomplete.contains(event.target)
      ) {
        console.log("Clicked outside, hiding suggestions"); // Debug log
        this.showSuggestions = false; // Hide suggestions when clicking outside
      }
    },
  },
};
</script>

<style scoped>
/* .autocomplete {
  position: relative;
} */

.autocomplete-items {
  z-index: 1050;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position:relative;
  top:5px;
}

.suggestion-item {
  padding: 5px 15px;
  cursor: pointer;
}

.suggestion-item.active {
  background-color: #e9e9e9;
  color: black;
}

.suggestion-item:hover {
  background-color: #e9e9e9;
  color: black;
}

/* body {
  overflow-x: visible;
} */
</style>
